import React, { useState } from "react";
import { flushSync } from "react-dom";
import DataTable from "components/DataTable";
// import PageWrapper from "../../components/PageWrapper";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { MemberManagement } from "../../config/tableConfigs";
import PageWrapperForm from "components/PageWrapperForm";
import UserFormModal from "./components/memberFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";
import AssignHierarchyModal from "./components/AssignHirerchyFormModal";

const MemberManagementPage = () => {
  const [modalShow, setModalShow] = useState(false); // show/hide modal
  const [modalMode, setModalMode] = useState("add"); // "add" or "edit"
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const { userid } = useSession();
  const [hierarchyModalShow, setHierarchyModalShow] = useState(false);
  const role = localStorage.getItem('role')
  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };
  // Change 1: Remove "Master Distributor" from canAssignHierarchy
  const canAssignHierarchy = ["Main Admin", "Admin", "White label"].includes(role);

  // Change 2: Restrict onView and onReport based on role
  const restrictedRoles = ["Master Distributor", "Distributer"];


  // Open modal for Edit

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("role_name", role);
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/retailer_action",
    MemberManagement,
    formdata,
    refresh
  );

  // Action handlers
  const handleView = (report) => {
    console.log("Viewing report:", report);
    // Navigate to detail page or open modal
    window.location.replace(`/member_setting_management?userid=${report.id}`);
  };

  const handleEditUser = (user) => {
    setModalMode("edit"); // switch to edit mode
    setSelectedUser(user); // pass selected row data
    setModalShow(true); // open modal
  };

  // const handleDelete = (report) => {
  //   if (window.confirm('Are you sure you want to delete this record?')) {
  //     console.log('Deleting report:', report);
  //     // Make API call to delete
  //     // Then refresh data: tableData.refetch();
  //   }
  // };
  // const [selectedUser, setSelectedUser] = useState(null);

  // const handleDelete = (user) => {

  //   setSelectedUser(user);

  //   // Wait for modal render before showing
  //   setTimeout(() => {
  //     const modalEl = document.getElementById("deleteUser1");
  //     if (modalEl) {
  //       const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
  //       modal.show();
  //     }
  //   }, 100);
  // };

  const handleDelete = (user) => {
    flushSync(() => setSelectedUser(user));  // React commits synchronously here
    const modalEl = document.getElementById("deleteUser1");
    if (modalEl) {
      const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
    }                          // selectedUser?.id is now correct
  };
  //  const canAssignHierarchy = ["Main Admin", "Admin", "White label", "Master Distributor"].includes(role);
  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    // Implement export functionality
    alert(`Exporting ${selectedIds.length} selected records`);
  };
  const handleOpenHierarchyModal = () => {
    setHierarchyModalShow(true);
  };
  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(
        `Are you sure you want to delete ${selectedIds.length} records?`
      )
    ) {
      console.log("Deleting selected records:", selectedIds);
      // Make API call to delete multiple records
      // Then refresh data: tableData.refetch();
    }
  };
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };
  const handleReport = (user) => {
    console.log("Checking report:", user);

    const data = {
      userid: user.id,
      role: user.Role
    };

    const encoded = btoa(JSON.stringify(data));

    window.location.href = `/user_main_wallet_reports?data=${encoded}`;
  };
  const handleHierarchySuccess = () => {
    setRefresh((prev) => prev + 1);
    setHierarchyModalShow(false);
  };
  const handleViewRestricted = restrictedRoles.includes(role) ? undefined : handleView;
  const handleReportRestricted = ["Master Distributor", "Distributer"].includes(role) ? undefined : handleReport;

  return (
    <div>
      <PageWrapperForm
        config={MemberManagement}
        handleOnclick={handleAddUser}
        buttonTitle={"Add Member"}
        secondaryButtonTitle={canAssignHierarchy ? "Add with Hierarchy" : undefined}
        handleSecondaryOnclick={canAssignHierarchy ? handleOpenHierarchyModal : undefined}
      >
        <DataTable
          config={MemberManagement}
          tableData={tableData}
          onView={handleViewRestricted}           // ❌ hidden for Master Distributor, Distributor
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onReport={handleReportRestricted}       // ❌ hidden for Master Distributor, Distributor, White label
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>
      <UserFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
        userRole={role}
      />
      {canAssignHierarchy && (
        <AssignHierarchyModal
          show={hierarchyModalShow}
          onClose={() => setHierarchyModalShow(false)}
          onSuccess={handleHierarchySuccess}
        />
      )}
      <DeleteModal
        id="deleteUser1"
        title="Delete User"
        deleteid={selectedUser?.id}
        message="Are you sure you want to delete this user?"
        apiUrl="https://pro.mokshiq.in/retailer_action" // 👈 pass API URL
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default MemberManagementPage;
